import React from 'react'

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  ModalFooter,
  HStack,
  Button,
} from '@chakra-ui/react'

import {TherapistSpecialty} from '@/api/models'
import useEditorModalState from '@/common/use-editor-modal'
import {CommonModalProps} from '@/utils/types'

import {emptyTherapistSpecialty} from '../constants'

const TherapistSpecialtyEditorModal = ({
  onClose,
  open,
  onComplete,
  item,
}: CommonModalProps & {item: TherapistSpecialty | null}) => {
  const {input, handleInputChange, handleUpsert, loading} = useEditorModalState<TherapistSpecialty>({
    table: 'therapist_specialties',
    item,
    emptyInput: emptyTherapistSpecialty,
    open,
    onComplete,
    onClose,
  })

  return (
    <Modal isOpen={open} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{item?.id ? 'Edytuj specjalność' : 'Utwórz specjalność'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing="4">
            <FormControl isDisabled={loading}>
              <FormLabel>Nazwa specjalności</FormLabel>
              <Input name="name" value={input.name ?? ''} onChange={handleInputChange} />
            </FormControl>
            <FormControl isDisabled={loading}>
              <Checkbox
                name="show_as_filter"
                isChecked={input.show_as_filter ?? false}
                onChange={handleInputChange}
              >
                Pokazuj jako filtr
              </Checkbox>
            </FormControl>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <HStack justifyContent="space-evenly">
            <Button isLoading={loading} onClick={handleUpsert} isDisabled={!input.name}>
              Zapisz
            </Button>
            <Button colorScheme="blue" variant="ghost" onClick={onClose} isDisabled={loading}>
              Anuluj
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default TherapistSpecialtyEditorModal
